import React, { Component } from 'react';
import Select from 'react-select';
import MaskField from './MaskField.jsx';
import BooleanField from './BooleanField.jsx';
import PasswordField from './PasswordField.jsx';
import StandardInput from './StandardInput.jsx';

class DynamicField extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (
      this.isType('boolean') &&
      !this.valueTypeValid('boolean') &&
      this.props.onValue
    ) {
      this.props.onValue(this.props.value === 'true');
    }
  }

  isType(expectedType) {
    return this.props.type === expectedType;
  }

  isStandardInput() {
    const distinctTypes = ['boolean', 'textarea', 'password', 'dropdown'];

    return !distinctTypes.includes(this.props.type);
  }

  valueTypeValid(type) {
    return this.props.value === '' || typeof this.props.value === type;
  }

  selectFieldName() {
    const fieldName = this.props.name;

    return this.props.fieldmeta ? fieldName + '[value]' : fieldName;
  }

  render() {
    return (
      <div className='dynamicFieldComponent'>
        <If condition={this.isStandardInput()}>
          {this.props.mask || this.isType('mac') ? (
            <MaskField
              autoFocus={this.props.focus}
              className={this.props.className}
              defaultValue={this.props.value}
              disabled={this.props.parentDisabled}
              guide={true}
              id={this.props.id}
              mask={this.props.mask}
              name={this.props.name}
              placeholder={this.props.placeholder}
              required={this.props.required}
              type={this.props.type}
              onChange={(e) => this.props.onValue(e.target.value)}
            />
          ) : (
            <StandardInput
              autoFocus={this.props.focus}
              disabled={this.props.parentDisabled}
              nameSuffix={(this.props.hasNameSuffix && '[value]') || ''}
              onChange={this.props.onValue}
              {...this.props}
            />
          )}
        </If>

        <If condition={this.isType('textarea')}>
          <textarea
            autoFocus={this.props.focus}
            className={this.props.className}
            disabled={this.props.parentDisabled}
            id={this.props.id}
            name={this.props.name}
            placeholder={this.props.placeholder}
            required={this.props.required}
            value={this.props.value}
            onChange={(e) => this.props.onValue(e.target.value)}
          />
        </If>

        <If condition={this.isType('password')}>
          <PasswordField
            ref={(el) => {
              this.passwordField = el;
            }}
            autoFocus={this.props.focus}
            disabled={this.props.parentDisabled}
            label='Generate Password'
            {...this.props}
          />
        </If>

        <If condition={this.isType('boolean')}>
          <BooleanField
            ref={(el) => {
              this.booleanField = el;
            }}
            disabled={this.props.parentDisabled}
            value={
              typeof this.props.value === 'undefined' ? '' : this.props.value
            }
            {...this.props}
          />
        </If>

        <If condition={this.isType('dropdown')}>
          <Select
            className={this.props.className}
            disabled={this.props.parentDisabled}
            id={this.props.id}
            isClearable={true}
            options={this.props.default}
            placeholder={this.props.placeholder}
            required={this.props.required}
            value={
              typeof this.props.value === 'undefined' ? '' : this.props.value
            }
            onChange={(e) => this.props.onValue(e !== null ? e.value : '')}
          />

          <div className='property-selector-dropdown'>
            <If condition={!this.props.supressFields}>
              <input
                readOnly
                name={this.selectFieldName()}
                type='hidden'
                value={
                  typeof this.props.value === 'undefined'
                    ? ''
                    : this.props.value
                }
              />
            </If>
          </div>
        </If>
      </div>
    );
  }
}

module.exports = DynamicField;
